module.exports = __webpack_public_path__ + "assets/img/wsj-select.8a8329a8.png";